import apolloClient from 'store/apolloClient';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';

import createAction from '../';
import * as services from '../../services/createUser';

export const CREATE_USER = createAsyncAction(createAction('CREATE_USER'));

export const createUser = (data) => dispatch => {
  dispatch({ type: CREATE_USER.pending });

  data.dateOfBirth = data.dateOfBirth ? `${ data.dateOfBirth }` : '';
  if (data.assignees) {
    data.assignees = data.assignees.map(item => item.key || item.userId) || []
  }

  const apiCallParams = {
    mutation: services.CREATE_USER,
    variables: {
     ...data,
    },
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { createUser: user } }) => {
      user.profile.dateOfBirth = Number(user.profile.dateOfBirth) || null;

      return dispatch({
        type: CREATE_USER.success,
        payload: { user: {
          ...user,
          ...user.profile,
        } },
      });
    },
    )
    .catch(err => {
      dispatch(errorAction(CREATE_USER.failure, err));
      throw err;
    });
};
